import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Canonical class combiner for the whole frontend — app code imports this via `@erp/ui`. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
